export function generateApiUrlByVersion(version) {
    var baseUrl = "".concat(process.env.REACT_APP_ARO_API_URL, "/api/v1") || 'http://localhost/api/v1';
    return baseUrl.replace(/\/v1[/]?/s, "/v".concat(version));
}
